// NOTE!!!! If you modify this profile you should modify recommender/referral-ui/env.js.template
declare const window: any;
export const environment = {
  production: true,
  clientId: window.__env.CLIENT_ID,
  apiUrl: window.__env.API_URL,
  instrumentationKey: window.__env.INSTRUMENTATION_KEY,
};
